// @core/api/endpoints/user/generate_referral_link.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GenerateReferralLinkRequest,
  GenerateReferralLinkResponse,
} from '../../../types/user';

const BASE_PATH = '/user';

/**
 * Generate personal referral link
 * Creates a unique referral link and code for the specified user. The link can be shared with others and tracks sign-ups attributed to this user's referral.
 */
export async function GenerateReferralLink(
  user_id: string,
  data: GenerateReferralLinkRequest,
  options?: RequestOptions
): Promise<GenerateReferralLinkResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:user_id/referral-link`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.post<GenerateReferralLinkResponse>(requestPath, data, requestOptions);
}
